import { formatCurrency } from "../date-utils";
export const companyInvoicePaymentEmailPreviewDtoFields = [{
        name: "cliente",
        title: "Cliente",
        render: (record) => record.company
    }, {
        name: "numeroFattura",
        title: "N° fattura/e",
        render: (record) => record.numeroFattura
    }, {
        name: "email",
        title: "Email",
        titleClass: "has-text-centered",
        dataClass: "has-text-centered",
        render: (record) => (record.email == null ? "" : record.email)
    }, {
        name: "pec",
        title: "Pec",
        titleClass: "has-text-centered",
        dataClass: "has-text-centered",
        render: (record) => (record.pec == null ? "" : record.pec)
    }, {
        name: "importo",
        title: "Importo",
        titleClass: "has-text-centered",
        dataClass: "has-text-centered",
        render: (record) => formatCurrency(record.importo) //new Intl.NumberFormat('it-IT', {style: 'currency',currency: 'EUR',minimumFractionDigits: 2,maximumFractionDigits: 2})
        //.format(record.invoice.importo)
    }];
